module.exports = __webpack_public_path__ + "img/bttn_carousel.c0e2bc1a.png";